<template>
  <div>
    <v-card>
      <v-toolbar flat height="90" outlined>
        <v-toolbar-title>
          <p
            class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text"
            style="white-space: normal"
          >
            <span v-if="prop === 'watts'">{{ reading.watts }}</span>
            <span v-if="prop === 'amps'">{{ reading.amps }}</span>
            <span v-if="prop === 'volts'">{{ reading.volts }}</span>
          </p>
          <p class="caption ma-0" style="font-size: 10px !important">
            <span v-if="prop === 'watts'">GROUP TOTAL POWER (WATTS)</span>
            <span v-if="prop === 'amps'">GROUP TOTAL CURRENT (AMPS)</span>
            <span v-if="prop === 'volts'">GROUP AVERAGE VOLTAGE (VOLTS)</span>
          </p>
        </v-toolbar-title>
      </v-toolbar>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "value",
  props: ["reading", "prop"],
};
</script>
